module.exports = __webpack_public_path__ + "img/noData.41ff6ebc.png";